import { makeStyles } from '@rbx/ui';

const useScopeTableStyles = makeStyles()((theme) => ({
  tableHeader: {
    backgroundColor: theme.palette.surface[300],
  },
  link: {
    textDecoration: 'none',
    color: 'inherit',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  endpointRoute: {
    whiteSpace: 'nowrap',
  },
}));

export default useScopeTableStyles;
